export function deepJSONParse(obj: any): any {
  if (typeof obj === "string") {
    try {
      return JSON.parse(obj);
    } catch {
      return obj;
    }
  } else if (typeof obj === "object" && obj !== null) {
    for (const key in obj) {
      obj[key] = deepJSONParse(obj[key]);
    }
  }
  return obj;
}